import styled from 'styled-components';
import MenuButton from '@Shared/MenuButton';

export const HeaderItemButton = styled(MenuButton)`
  margin-right: 17px;
  padding: 7px 0 0;
  border-bottom: 5px solid transparent;

  &:before {
    position: absolute;
    content: '';
    width: 0;
    height: 0;
    border: 7px solid transparent;
    margin: auto;
    bottom: -10px;
  }

  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    position: relative;

    &:before {
      bottom: -15px;
      left: calc(50% - 6px);
    }
  }

  ${props =>
    props.isActive &&
          `
    border-color: ${props.theme.carvana.blue.primary};
    color: ${props.theme.carvana.blue.primary};
    &:before {
      border-top: 4px solid ${props.theme.carvana.blue.primary};
    }
  `} @media(min-width: ${props => props.theme.breakpoints.values.md}px) {
  margin-right: 26px;
}
`;
export const HeaderItems = styled.div`
  flex: 1;
  height: 100%;
  display: flex;
`;


